import { render, staticRenderFns } from "./PcWatch.vue?vue&type=template&id=6be5a580&"
import script from "./PcWatch.vue?vue&type=script&lang=js&"
export * from "./PcWatch.vue?vue&type=script&lang=js&"
import style0 from "./PcWatch.vue?vue&type=style&index=0&id=6be5a580&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports